import { connect } from 'react-redux';

import * as organizationConstants from '../../constants/organizations';
import ChangeUserRole from '../../components/ChangeUserRole';

const mapDispatchToProps = dispatch => ({
    onSubmit: payload =>
        dispatch({
            type: organizationConstants.CHANGE_USERS_ROLE_REQUEST,
            payload,
        }),
});

export default connect(
    undefined,
    mapDispatchToProps,
)(ChangeUserRole);



// WEBPACK FOOTER //
// ./src/containers/appDialog/ChangeUserRoleInOrganization.js